<template>
  <div class="info">
    <HomePic/>
    <BreadNav/>
    <div class="sub-main">
<!--      <div class="left">-->
<!--        <LeftMenu/>-->
<!--      </div>-->
      <div class="right" >
        <div class="news-box"  id="printArea">
          <div class="title">{{news.title}}</div>
          <div class="info">发布日期：{{news.showDate}}
            &#12288; &#12288; &#12288; &#12288; &#12288;
            点击数：{{news.viewNum}}&#12288; &#12288; &#12288; &#12288; &#12288;
<!--          <span class="print noprint" v-print="print">【打印本页】</span></div>-->
          <span class="print noprint" @click="sysPrint">【打印本页】</span></div>
          <div class="w-e-text-container" style="margin-top: 10px">
<!--            <div v-html="html" data-slate-editor></div>-->
            <div class="content" v-html="news.content" data-slate-editor></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
</style>

<script>
import HomePic from '@/components/style1/HomePic.vue';
import BreadNav from '@/components/style1/BreadNav.vue';
import { get } from '@/util/Http';

export default {
  name: 'NewsDetail',
  components: {
    HomePic, BreadNav,
  },
  data() {
    return {
      news: {
        id: '',
        title: '',
        showDate: '',
        content: '',
        viewNum: 0,
      },
      print: {
        id: 'printArea',
        popTitle: '', // 打印配置页上方标题
        extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
        preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
        previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
        previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
        zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
        previewBeforeOpenCallback() {}, // 预览窗口打开之前的callback（开启预览模式调用）
        previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
        beforeOpenCallback() {}, // 开启打印前的回调事件
        openCallback() {}, // 调用打印之后的回调事件
        closeCallback() {}, // 关闭打印的回调事件（无法确定点击的是确认还是取消）
        url: '',
        standard: '',
        extraCss: '',
      },
    };
  },
  mounted() {
    this.getNewsDetail();
  },
  methods: {
    getNewsDetail() {
      get(`/news/${this.$route.query.id}`)
        .then((result) => {
          if (result.status === 200) {
            this.news = result.data.news;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sysPrint() {
      window.print();
    },
  },
};
</script>
<style src="../../../node_modules/@wangeditor/editor/dist/css/style.css"></style>
